var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var AvailabilityBusiness = function (storeContainer) {
    var store = storeContainer.store;
    var _a = store.newCreateRequestStore, progressStore = _a.progressStore, problemStore = _a.problemStore, homeStore = _a.homeStore, questionsStore = _a.questionsStore, availabilityStore = _a.availabilityStore, commonStore = _a.commonStore, reviewStore = _a.reviewStore;
    var propsConnect = {
        currentUser: homeStore.currentUser,
        selectedAvailabilityTimes: availabilityStore.selectedAvailabilityTimes,
        isCritical: availabilityStore.isCritical,
        isNextDiabled: availabilityStore.isNextDiabled,
        timeBlockList: availabilityStore.timeBlockList,
        slaStartTime: availabilityStore.slaStartTime,
        slaEndTime: availabilityStore.slaEndTime,
        isShowAavilability: availabilityStore.isShowAavilability,
        calendarDate: availabilityStore.calendarDate,
        loading: availabilityStore.loading,
        isRender: availabilityStore.isRender,
        isShowAutoSchedule: availabilityStore.isShowAutoSchedule,
        autoScheduleInfo: availabilityStore.autoScheduleInfo,
        scheduleTimeBlocks: availabilityStore.scheduleTimeBlocks,
        isShowBundle: availabilityStore.isShowBundle,
        isShowAllOptions: availabilityStore.isShowAllOptions,
        selectedSchedule: availabilityStore.selectedSchedule,
        isAutoScheduleNextDisabled: availabilityStore.isAutoScheduleNextDisabled,
        bundleWOs: availabilityStore.bundleWOs,
        autoScheduleRecommendLength: availabilityStore.autoScheduleRecommendLength,
        availabilityStep: availabilityStore.availabilityStep,
        availabilityType: availabilityStore.availabilityType,
        flexibleType: availabilityStore.flexibleType,
        isSkip: availabilityStore.isSkip,
        isSwitchToFlexible: availabilityStore.isSwitchToFlexible,
        isSwitchToLimited: availabilityStore.isSwitchToLimited,
        isStay: availabilityStore.isStay,
        utcOffset: availabilityStore.utcOffset,
        contactPhone: availabilityStore.contactPhone,
        contactFlagofPhonesForTextMessagingApproved: availabilityStore.contactFlagofPhonesForTextMessagingApproved,
        contactIsOriginApproved: availabilityStore.contactIsOriginApproved,
        contactOriginPhone: availabilityStore.contactOriginPhone
    };
    var dispatchConnect = {
        next: progressStore.next,
        init: availabilityStore.init,
        initData: function () { return availabilityStore.initData({
            priority: commonStore.priority,
            woTypeId: commonStore.woTypeId,
            serviceCategoryId: problemStore.serviceCategoryId,
            serviceTypeId: problemStore.serviceTypeId,
            serviceCodeId: problemStore.serviceCodeId,
            isRecallCheck: commonStore.isRecallCheck,
        }); },
        setAvailabilityTime: availabilityStore.setAvailabilityTime,
        clearAvailabilityTime: availabilityStore.clearAvailabilityTime,
        updateTimeBlockList: availabilityStore.updateTimeBlockList,
        clearAvailabilityData: availabilityStore.clear,
        getAvailabilityData: availabilityStore.getAvailabilityData,
        handleSelectedForReviewDisplay: availabilityStore.handleSelectedForReviewDisplay,
        updateCalendarDate: availabilityStore.updateCalendarDate,
        setAvailabilityParams: availabilityStore.setParams,
        setSelectedSchedule: availabilityStore.setSelectedSchedule,
        getAutoScheduleData: availabilityStore.getAutoScheduleData,
        setTargetDisclaimer: reviewStore.setTargetDisclaimer,
        switchToLimited: availabilityStore.switchToLimited,
        switchToFlexible: availabilityStore.switchToFlexible,
        checkExpirationTime: availabilityStore.checkExpirationTime,
        getResidentInfo: availabilityStore.getResidentInfo,
        canSchedule: availabilityStore.canSchedule,
        updateSummaryPhoneData: availabilityStore.updateSummaryPhoneData,
        sameDayCheck: availabilityStore.sameDayCheck
    };
    return __assign(__assign({}, propsConnect), dispatchConnect);
};
